import { Injectable } from '@angular/core';

export const identityPoolId = 'aws.cognito.identity-id.us-east-1:bae5c41f-cb27-4ac6-9ac1-05977f7812d0';

/* pe */
export const pythonServerApiKey = 'b98x9xlfs54ws4k0wc0o8g4gwc0w8ss';
export const peWords = 'pw-pe'; // StorageReplaceWords
export const peChanges = 'pw-pe-changes'; // StorageReplaceWords

export const upgradePromptMsg = 'Please upgrade to use this feature!';
export const convertWithFreeVoiceNeedUpgradeMsg = 'Free Voices are not available for this feature. <br> Please upgrade to Paid Plans to use this feature with Premium/Plus Voices.';
export const convertWithPremVoiceNeedUpgradeMsg = 'Please upgrade to Premium Plan to use this feature with Premium Voices.';
export const convertWithPlusVoiceNeedUpgradeMsg = 'Please upgrade to Plus Plan to use this feature with Plus Voices.';
export const whatIsOCRMsg = 'OCR (optical character recognition) is a technology that enables you to convert different types of documents, such as scanned paper documents, PDF files or images captured by a digital camera into editable and searchable data.';
export const needOcrText = 'This file requires <a target=\'_blank\' href=\'https://www.naturalreaders.com/personalwebfaq.html#tech\' class=\'need-underline\'>OCR</a> to be read.';
export const needOcrTextSW = 'This file requires <a class=\'need-underline\'>OCR</a> to be read.';
export const voiceCantBeConvertedMsg = 'Voices with <img src="assets/img/no_mp3.png" loading="lazy"> are not available to convert to MP3.';
export const whatIsLocalAcaMsg = 'You can use local aca voice on offline.';
export const bookMarkList = 'pw-bm';

/* Audio */
export const audiosDeletedMsg = 'Audios deleted succesfully';
export const audiosDeleteFailedMsg = 'Failed to delete audios';
export const audiosFolderDeleteFailedMsg = 'Failed to delete folders';

/* Audio-list/convert */
export const convertSuccessMsg = 'CONVERT_SUCCESS';
export const convertPartialSuccessMsg = 'CONVERT_PARTIAL_SUCCESS';
export const convertProgressMsg = 'CONVERT_PROGRESS';
export const cancelConvertMsg = 'CONVERT_CANCEL';
export const cancelConvertSuccessMsg = 'AUDIO_CANCEL_CONVERT_SUCCESS';
export const cancelInProgressMsg = 'ERR_CANCEL_IN_PROGRESS';
export const failedToDeleteAudioMsg = 'ERR_DELETE_FAILED';
export const convertCharsAllowed = 1000000;
export const conversionHasBegunPopupMsg = 'Conversion has already begun.';
export const audioDeletedPopupMsg = 'Deleted!';
export const conversionCanceledPopupMsg = 'Conversion has been canceled.';
export const pdfContentTooLongMsg = 'Please select a page range that contains less than 50,000 characters.';
export const inputContentTooLongMsg = 'Please convert only 50,000 characters at a time.';
export const pdfContentTooShortMsg = 'No text detected in this range.';
export const voiceChangedToPremiumVoiceMsg = 'unavailable for mp3 converting, replaced with last selected premium voice:';
export const convertLimitMsg = 'Mp3 conversion limitations: 1,000,000 characters / month from subscription date.';
export const convertLimitResetMsg = 'You have reached the 1,000,000 characters per month limit for mp3 conversion.\nYour characters will reset on';
export const convertLimitErrorMsg = 'You have reached the 1,000,000 characters per month limit for mp3 conversion.';
export const convertReadyMsg = 'Ready to convert';
export const convertFailedMsg = 'Convert failed';
export const convertInProgressMsg = 'Converting to mp3';
export const convertAiffInProgressMsg = 'Converting to aiff';
export const convertWavInProgressMsg = 'Converting to wav';
export const convertCafInProgressMsg = 'Converting to caf';
export const convertCompleteMsg = 'Convert complete';
export const convertCompleteIosAcaMsg = 'Converted audio is in folder icloud drive/personalweb.';
export const convertCompleteAndroidSystemMsg = 'Converted audio is in the download folder.';

// File
export const fileNotAvailableToShareMsg = 'The file is not online available to share. Please upload the file again.';
export const failedToShareFileMsg = 'Failed to share the file.';
export const failedToUnshareFileMsg = 'Failed to unshare the file';

// Alert Messages
export const errorAndContactUsMsg = 'Refresh the page. If the problem persists for more than 5 minutes,' +
    ' please <a href=\'https://www.naturalreaders.com/exploring.html?index=2&info=contactus\'>contact us</a>' +
    ' with your error message and email login ID.';
export const genericErrorMsg = 'Oops! Something went wrong.';
export const deleteAccountMsg = 'Are you sure you want to delete your account? You won\'t be able to recover it';
export const fileUpdateErrorMsg = 'Error: We were not able to update your file in the server,' +
    'the file update will not be reflected on next use.';
export const fileNotOnlineMsg = 'Cannot add bookmarks - file is available locally only.';

// Billing
export const freePlan = 'Free User License';
export const premPlan = 'Web Premium License';
export const plusPlan = 'Web Premium Plus License';
export const eduTrialPremPlan = 'EDU Premium Group License (Free Trial)';
export const loginRequiredPromptMsg = 'Please <a href=\'/login-service/login?redir=pw&dest=online\' class=\'need-underline\'>login</a> to use this feature!';
export const loginPromptMsg = 'Please sign-up and purchase a premium membership to use this feature.';
export const nextRenewalMsg = 'Your next renew date is';
export const licenseExpireMsg = 'Your license will expire after';
export const cancelRenewMsg = 'If you have any questions, comments, or issues, please contact us. If you change your mind after ' +
    'cancelling, return to this page and select \'Renew Subscription\'. To request a refund, please contact us.';
export const failToCancelRenewMsg = `${genericErrorMsg} Please try again later.`;


@Injectable({
  providedIn: 'root'
})
export class ConstantService {

  constructor() { }
}
